import Region from "../../../../../models/Region";
import { sequenceTypeIndex } from "../../../constants/sequences";
import Codon from "./Codon";

class Exon {
  constructor(sequence, transcript) {
    const { start, end, type, exonIndex } = sequence;
    const { triploHaploIndex } = transcript;
    const { chromosome } = transcript.region;
    const isCDS = type === "CDS";
    this.exonIndex = exonIndex;
    this.typeIndex = isCDS ? triploHaploIndex : sequenceTypeIndex[type];
    this.transcript = transcript;
    this.region = new Region(start, end + 1, chromosome);
    this.sequence = sequence["protein-sequence"] || "";
    this.codons = null;
  }

  static isCoding(seq) {
    return seq.type === "CDS";
  }

  get x0() {
    return this.region.g0;
  }

  get x1() {
    return this.region.g1;
  }

  fixSplitCodons(ind) {
    const { strand, region, exons } = this.transcript;
    const prevSeq = exons[ind - 1];
    const prevCodons = prevSeq?.codons || [];
    let prevCodon = prevCodons[prevCodons.length - 1];
    const prevSize = prevCodon?.size || 0;
    const offsetDiff = -((strand * prevSize) % 3);
    const aminoArr = this.sequence.replace(/[-|>]/g, "").split("");
    const codons = aminoArr.map((x) => new Codon(x, this));

    const seqX0 = this.region.x0 - region.x0;
    const seqX1 = this.region.x1 - region.x0;

    const seqStart = strand === 1 ? seqX0 : seqX1;
    const offset = strand === 1 ? offsetDiff : offsetDiff - 3;
    const start = seqStart + offset;

    for (let i = 0; i < codons.length; i++) {
      const codon = codons[i];
      const codonX0 = start + i * 3 * strand;
      const codonX1 = codonX0 + 3;
      const index = prevCodon?.codonIndex || 0;
      if (i === 0 || i === codons.length - 1) {
        const x0 = Math.max(codonX0, seqX0);
        const x1 = Math.min(codonX1, seqX1);
        const size = x1 - x0;
        const skipIndex = i === 0 && size < 3;
        codon.setPosition(x0, x1, index + (skipIndex ? 0 : 1));
      } else {
        codon.setPosition(codonX0, codonX1, index + 1);
      }

      prevCodon = codon;
    }

    this.codons = codons;
    return codons;
  }
}

export default Exon;
